import {EventBus} from "@/utils/event-bus";
window.cef3={
  emit: function (eventName,data) {
    EventBus.$emit(eventName,data)
  }
}



// WEBPACK FOOTER //
// ./src/utils/cefUtil.js